export class CommentsRequestModel {
    comment: string;
    userId: string;
    source: string;
    purpose: string;
    documentId: string;
}

export class CommentsResponseModel {
    comment: string;
    createdAt: string;
    documentId: string;
    id: string;
    orderId: string;
    orderInteractionPurpose: string;
    orderInteractionSource: string;
    updatedAt: string;
    userId: string;
}




// WEBPACK FOOTER //
// ./src/app/_models/comments/CommentsModel.ts